import loadable from '@loadable/component';
import { type FunctionComponent, type HTMLAttributes } from 'react';
import { useInView } from 'react-intersection-observer';

const LoadableProductListResults = loadable(
	() => import(/* webpackChunkName: "product-list-results" */ './search-product-list-results.component'),
	{
		resolveComponent: ({ ProductListResults }) => ProductListResults
	}
);

export type SearchProductListsProps = Pick<HTMLAttributes<HTMLElement>, 'className'>;
export const SearchProductLists: FunctionComponent<SearchProductListsProps> = ({ className = 'mt4 mt5-l w-100' }) => {
	const defaultClasses = 'dn flex-ns flex-column justify-center';
	const { ref: sectionRef, inView: isVisible } = useInView({ triggerOnce: true, rootMargin: '0px 0px 200px 0px' });

	return (
		<section className={`${defaultClasses} ${className}`} ref={sectionRef} data-testid="search-product-lists">
			{isVisible && <LoadableProductListResults />}
		</section>
	);
};
